import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ENTORNO } from '../../config/config';
import authContext from '../../context/authentication/authContex';
import Routes_gral from '../../utils/Routes_gral';
import logoMoviport from '../../images/Logo_MOVIPORT.png';
import logoCasport from '../../images/Logo_CASPORT.png';
import './ModalTerms.css';

const codigoConductaCasport = {
  intro: [
    'Uno de los pilares fundamentales de nuestra Política de Calidad dice expresamente:',
    'Nuestros valores de honestidad, profesionalismo y seriedad guían cada una de nuestras acciones y son base para fortalecer la confianza y el compromiso con todas nuestras partes interesadas.',
    'En función de esta premisa implementamos este Código de Conducta para Proveedores a fin de garantizar la integridad y transparencia en todos los procesos de compras de bienes y servicios.',
    'Las reglas básicas y fundamentales que guían todo tipo de transacciones entre personal de Casport y los Proveedores se detallan a continuación:',
  ],
  items: [
    { text: 'Debe entenderse con Proveedores a cualquier persona o compañía que preste servicios o provea cualquier tipo de bienes a Casport.' },
    { text: 'Bajo ninguna circunstancia los Proveedores deberán acatar una orden o instrucción por parte de personal de Casport que pudiera constituir un incumplimiento a lo dispuesto en esté Código.' },
    { text: 'Los Proveedores deben evitar cualquier relación con empleados de la Empresa que pueda dar lugar a un conflicto respecto a los intereses de Casport. Por ejemplo, los Proveedores no deben contratar, efectuar pagos o intercambio de bienes o servicios a ningún empleado de Casport mientras dure la relación comercial.' },
    { text: 'En caso de que exista una relación de parentesco entre un empleado del Proveedor y un empleado de Casport (por ejemplo, cónyuge, padre, hermano, abuelo, hijo, nieto, familiar político, etc.), o si un empleado del Proveedor mantiene otro tipo de relación con un empleado de Casport que pudiera representar un conflicto de intereses, el Proveedor debe informar tal circunstancia a la compañía.' },
    {
      text: 'Los Proveedores no deben ofrecer ningún obsequio, intercambio de bienes, viajes, comidas o actividad de entretenimiento a ningún empleado de Casport en circunstancias que pudieran influenciar las decisiones de dicho empleado respecto del Proveedor, o que pudieran interpretarse en tal sentido. Están permitidos obsequios modestos, comidas o actividades de entretenimiento siempre que no se trate de:',
      subItems: [
        'Dinero en efectivo o equivalente en bienes',
        'No se repita en forma frecuente ni sea costoso',
      ],
    },
    { text: 'Bajo ninguna circunstancia los Proveedores deben ser parte de ningún cohecho comercial o soborno, ni ofrecer ningún tipo de incentivo a ningún empleado de Casport ni a familiares o amigos de empleados de Casport con el fin de obtener una ventaja comercial.' },
    { text: 'En caso de que un Proveedor tenga conocimiento sobre algún tipo de conducta ilegal o indebida por parte de un empleado de Casport o cualquier persona que actúe en nombre de Casport vinculado con la prestación de servicios o provisión de suministros debe informarlo a Casport. Dicho informe debe efectuarse a través del mail denunciasproveedores@Casport.com.ar especialmente creado para atender cualquier evento relacionado con incumplimientos al presente Código' },
    { text: 'La relación del Proveedor con Casport no se verá afectada por un informe siempre que sea honesto y veraz vinculado con un acto de conducta indebida.' },
    {
      text: 'Los Proveedores deberán mantener la más estricta confidencialidad sobre la información técnica. Comercial, financiera, operativa o estratégica a la que tenga acceso como consecuencia de su relación con la Empresa. Esta obligación incluye:',
      subItems: [
        'No divulgar información a terceros sin autorización previo y fehaciente',
        'Utilizar la información únicamente para el cumplimiento de las obligaciones contractuales.',
        'Proteger los documentos, planos, especificaciones y cualquier otra información confidencial contra accesos no autorizados.',
        'Mantener la obligación de confidencialidad incluso después de finalizada la relación comercial con la Empresa.',
      ],
    },
    { text: 'El incumplimiento de las obligaciones detalladas en este Código de Conducta podrá constituir una falta grave y dar lugar a la recisión del vínculo comercial, sin perjuicio de las acciones legales que pudieran corresponder.' },
  ],
};

const codigoConductaMoviport = {
  intro: [
    'Uno de los pilares fundamentales de nuestra Política de Calidad dice expresamente:',
    'MoviPort S.A., empresa orientada a proveer servicios de recepción, acopio, almacenaje, mezclado, fraccionado, despacho y transporte, implementa esta política para lograr satisfacer los requisitos y necesidades de nuestros clientes, en un contexto de honestidad, seguridad, profesionalismo y respeto por el medio ambiente.',
    'En función de esta premisa implementamos este Código de Conducta para Proveedores a fin de garantizar la integridad y transparencia en todos los procesos de compras de bienes y servicios.',
    'Las reglas básicas y fundamentales que guían todo tipo de transacciones entre personal de Moviport SA y los Proveedores se detallan a continuación:',
  ],
  items: [
    { text: 'Debe entenderse con Proveedores a cualquier persona o compañía que preste servicios o provea cualquier tipo de bienes a Moviport SA.' },
    { text: 'Bajo ninguna circunstancia los Proveedores deberán acatar una orden o instrucción por parte de personal de Moviport SA que pudiera constituir un incumplimiento a lo dispuesto en esté Código.' },
    { text: 'Los Proveedores deben evitar cualquier relación con empleados de la Empresa que pueda dar lugar a un conflicto respecto a los intereses de Moviport SA. Por ejemplo, los Proveedores no deben contratar, efectuar pagos o intercambio de bienes o servicios a ningún empleado de Moviport SA mientras dure la relación comercial.' },
    { text: 'En caso de que exista una relación de parentesco entre un empleado del Proveedor y un empleado de Moviport SA (por ejemplo, cónyuge, padre, hermano, abuelo, hijo, nieto, familiar político, etc.), o si un empleado del Proveedor mantiene otro tipo de relación con un empleado de Moviport SA que pudiera representar un conflicto de intereses, el Proveedor debe informar tal circunstancia a la compañía.' },
    {
      text: 'Los Proveedores no deben ofrecer ningún obsequio, intercambio de bienes, viajes, comidas o actividad de entretenimiento a ningún empleado de Moviport SA en circunstancias que pudieran influenciar las decisiones de dicho empleado respecto del Proveedor, o que pudieran interpretarse en tal sentido. Están permitidos obsequios modestos, comidas o actividades de entretenimiento siempre que no se trate de:',
      subItems: [
        'Dinero en efectivo o equivalente en bienes',
        'No se repita en forma frecuente ni sea costoso',
      ],
    },
    { text: 'Bajo ninguna circunstancia los Proveedores deben ser parte de ningún cohecho comercial o soborno, ni ofrecer ningún tipo de incentivo a ningún empleado de Moviport SA ni a familiares o amigos de empleados de Moviport SA con el fin de obtener una ventaja comercial.' },
    { text: 'En caso de que un Proveedor tenga conocimiento sobre algún tipo de conducta ilegal o indebida por parte de un empleado de Moviport SA o cualquier persona que actúe en nombre de Moviport SA vinculado con la prestación de servicios o provisión de suministros debe informarlo a Moviport SA. Dicho informe debe efectuarse a través del mail denunciasproveedores@Moviportsa.com.ar especialmente creado para atender cualquier evento relacionado con incumplimientos al presente Código' },
    { text: 'La relación del Proveedor con Moviport SA no se verá afectada por un informe siempre que sea honesto y veraz vinculado con un acto de conducta indebida.' },
    {
      text: 'Los Proveedores deberán mantener la más estricta confidencialidad sobre la información técnica. Comercial, financiera, operativa o estratégica a la que tenga acceso como consecuencia de su relación con la Empresa. Esta obligación incluye:',
      subItems: [
        'No Divulgar información a terceros sin autorización previo y fehaciente',
        'Utilizar la información únicamente para el cumplimiento de las obligaciones contractuales.',
        'Proteger los documentos, planos, especificaciones y cualquier otra información confidencial contra accesos no autorizados.',
        'Mantener la obligación de confidencialidad incluso después de finalizada la relación comercial con la Empresa.',
      ],
    },
    { text: 'El incumplimiento de las obligaciones detalladas en este Código de Conducta podrá constituir una falta grave y dar lugar a la recisión del vínculo comercial, sin perjuicio de las acciones legales que pudieran corresponder.' },
  ],
};

const esCasport = ENTORNO.toLowerCase().includes('casport');

const codigoConducta = esCasport ? codigoConductaCasport : codigoConductaMoviport;
const logoEmpresa = esCasport ? logoCasport : logoMoviport;

const EMAIL_REGEX = /[\w.+-]+@[\w-]+\.[\w.-]+/g;

const renderWithEmail = (text) => {
  const parts = text.split(EMAIL_REGEX);
  const emails = text.match(EMAIL_REGEX) || [];
  return parts.reduce((acc, part, idx) => {
    acc.push(part);
    if (emails[idx]) {
      acc.push(
        <span className="modalTermsEmail" key={`email-${idx}`}>
          {emails[idx]}
        </span>
      );
    }
    return acc;
  }, []);
};

const SCROLL_END_THRESHOLD = 4;

const ModalTerms = ({ onAccept }) => {
  const [aceptado, setAceptado] = useState(false);
  const [scrollCompleto, setScrollCompleto] = useState(false);
  const textRef = useRef(null);
  const navigate = useNavigate();
  const { cerrarSesion } = useContext(authContext);

  const handleCancelar = () => {
    cerrarSesion();
    navigate(Routes_gral.login);
  };

  const handleScroll = (e) => {
    if (scrollCompleto) return;
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - SCROLL_END_THRESHOLD) {
      setScrollCompleto(true);
    }
  };

  useEffect(() => {
    const el = textRef.current;
    if (el && el.scrollHeight - el.clientHeight <= SCROLL_END_THRESHOLD) {
      setScrollCompleto(true);
    }
  }, []);

  return (
    <div className="modalTermsBackground">
      <div className="modalTermsContainer">
        <img
          className="modalTermsLogo"
          src={logoEmpresa}
          alt="Logo-Empresa"
        />
        <h3>Términos y Condiciones</h3>
        <div
          className="modalTermsText"
          ref={textRef}
          onScroll={handleScroll}
        >
          <p>
            Para continuar utilizando el Portal de Proveedores, es necesario
            que lea y acepte los términos y condiciones de uso.
          </p>
          <h4>Código de Conducta para Proveedores</h4>
          {codigoConducta.intro.map((parrafo, idx) =>
            idx === 1 ? (
              <p key={`intro-${idx}`}>
                <strong>
                  <em>{parrafo}</em>
                </strong>
              </p>
            ) : (
              <p key={`intro-${idx}`}>{parrafo}</p>
            )
          )}
          <ol>
            {codigoConducta.items.map((item, idx) => (
              <li key={`item-${idx}`}>
                {renderWithEmail(item.text)}
                {item.subItems && (
                  <ul>
                    {item.subItems.map((subItem, subIdx) => (
                      <li key={`item-${idx}-sub-${subIdx}`}>{subItem}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ol>
        </div>
        {!scrollCompleto && (
          <p className="modalTermsScrollHint">
            Debe leer todo el documento para poder aceptar los términos y condiciones.
          </p>
        )}
        {scrollCompleto && (
          <label className="modalTermsCheckLabel">
            <input
              type="checkbox"
              checked={aceptado}
              onChange={(e) => setAceptado(e.target.checked)}
            />
            He leído y Acepto Términos y Condiciones
          </label>
        )}
        <div className="modalTermsBtnRow">
          <button
            className="modalTermsCancelBtn"
            onClick={handleCancelar}
          >
            Cancelar
          </button>
          <button
            className="modalTermsAcceptBtn"
            disabled={!aceptado}
            onClick={onAccept}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalTerms;
